let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("22DNY")).then(() => parcelRequire('6VDyY'));